module.exports = __webpack_public_path__ + "static/media/wolffox3_preview.4b86791a.jpg";